import React from "react";
import { useProvider } from "./StateProvider";

const Songitem = ({
  likedBy,
  numberOfLikes,
  songName,
  songUrl,
  userId,
  userName,
  id,
}) => {
  const { user, db } = useProvider();

  const handleLike = () => {
    db.collection("songs")
      .doc(id)
      .set({
        likedBy: likedBy.includes(user.uid)
          ? likedBy.filter((item) => {
              return item !== user.uid;
            })
          : [...likedBy, user.uid],
        numberOfLikes: !likedBy.includes(user.uid)
          ? numberOfLikes + 1
          : numberOfLikes - 1,
        songName,
        songUrl,
        userId,
        userName,
        id,
      });
  };

  return (
    <>
      <div className="card mb-1 shadow">
        <div className="card-body row align-items-center justify-content-center">
          <div className="col-12 col-md-2 h3 mb-1">
            {numberOfLikes}
            <i
              className={`fa${
                likedBy.includes(user.uid) ? "s" : "r"
              } fa-thumbs-up ml-3 ${
                likedBy.includes(user.uid) ? "text-primary" : ""
              }`}
              onClick={handleLike}
            ></i>
          </div>
          <div className="col-12 col-md-4 mb-1">
            <div className="d-flex flex-column">
              <div className="h5">{songName}</div>
              <div className="text-muted">{userName}</div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <audio className="w-100" controls>
              <source src={songUrl} type="audio/mpeg" />
            </audio>
          </div>
        </div>
      </div>
    </>
  );
};

export default Songitem;
